var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86693 0C5.59683 0 5.33822 0.109261 5.14994 0.302922L4.66667 0.8H0.799999C0.358171 0.8 0 1.15817 0 1.6C0 2.04183 0.358172 2.4 0.8 2.4H0.862847L2.25738 14.5875C2.34857 15.3872 3.01933 16 3.8023 16H10.1977C10.9807 16 11.6514 15.3872 11.7426 14.5875L13.1372 2.4H13.2C13.6418 2.4 14 2.04183 14 1.6C14 1.15817 13.6418 0.8 13.2 0.8H12.4444H9.33333L8.85006 0.302922C8.66178 0.109261 8.40317 0 8.13307 0H5.86693ZM2.42904 2.4H3.11111H11.571L10.1977 14.4H3.8023L2.42904 2.4ZM5.44444 4C5.01489 4 4.66667 4.34822 4.66667 4.77778V12C4.66667 12.4416 5.01511 12.8 5.44444 12.8C5.874 12.8 6.22222 12.4518 6.22222 12.0222V4.77778C6.22222 4.34822 5.874 4 5.44444 4ZM8.55556 4C8.126 4 7.77778 4.34822 7.77778 4.77778V12.0222C7.77778 12.4518 8.126 12.8 8.55556 12.8C8.98489 12.8 9.33333 12.4416 9.33333 12V4.77778C9.33333 4.34822 8.98511 4 8.55556 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.648ec6c3c0989512228eede3b4684999.svg";
export { ForwardRef as ReactComponent };